import { createAction } from 'redux-actions';

export const getCompanyInfoRequested = createAction('GET_COMPANY_INFO_REQUEST');
export const getCompanyInfoReceived = createAction('GET_COMPANY_INFO_RECEIVED');
export const getCompanyInfoReceiveFailure = createAction('GET_COMPANY_INFO_RECEIVE_FAILURE');
export const getCompanyInfoClear = createAction('GET_COMPANY_INFO_CLEAR');
